<template>
  <div v-if="isVisible" class="bg-opacity-70 absolute inset-0 z-50 flex items-center justify-center bg-black">
    <div class="flex flex-col items-center rounded-lg bg-gray-800 p-8 text-white shadow-xl">
      <svg class="mb-4 h-16 w-16 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
      </svg>
      <h3 class="mb-2 text-xl font-semibold">Drop files to upload</h3>
      <p class="text-gray-300">Release to add assets to your project</p>
    </div>
  </div>
</template>

<script setup>
defineProps({
  isVisible: {
    type: Boolean,
    default: false,
  },
});
</script>
